import "./App.css";
import Routers from "./Routers/Routers";

function App() {
  return (
    <div className="app-shell">
      <Routers />
    </div>
  );
}

export default App;
